
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { StatusDialog } from "./StatusDialog";
import { StatusesTable } from "./StatusesTable";
import { useToast } from "@/hooks/use-toast";
import { Flag } from "lucide-react";

export const StatusesContainer = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState<any>(null);
  const { toast } = useToast();

  const { data: statuses, refetch } = useQuery({
    queryKey: ["policy_statuses"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("policy_statuses")
        .select("*")
        .order("order", { ascending: true })
        .order("name");

      if (error) throw error;
      return data;
    },
  });

  const handleEdit = (status: any) => {
    setSelectedStatus(status);
    setIsDialogOpen(true);
  };

  const handleAdd = () => {
    setSelectedStatus(null);
    setIsDialogOpen(true);
  };

  const handleReorder = async (reorderedItems: any[]) => {
    try {
      for (const item of reorderedItems) {
        const { error } = await supabase
          .from("policy_statuses")
          .update({ order: item.order })
          .eq("id", item.id);

        if (error) throw error;
      }
      
      toast({
        title: "Success",
        description: "Status order updated successfully",
      });
      
      refetch();
    } catch (error) {
      console.error("Error updating status order:", error);
      toast({
        variant: "destructive",
        title: "Error",
        description: "Failed to update status order",
      });
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-semibold mb-4">Manage Policy Statuses</h2>
        <Button onClick={handleAdd} className="bg-primary hover:bg-primary/90 text-white">
          <Flag className="h-4 w-4 mr-2" />
          Add Policy Status
        </Button>
      </div>

      <StatusesTable
        statuses={statuses || []}
        onEdit={handleEdit}
        onReorder={handleReorder}
      />

      <StatusDialog
        status={selectedStatus}
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        onSuccess={() => {
          refetch();
          setIsDialogOpen(false);
        }}
      />
    </div>
  );
};
